export default __webpack_public_path__ + "f5fdecb5b7bdd19f31ac3c2522fb9b88.svg";